var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBarricade = function SvgIconBarricade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 16v2.75a1 1 0 1 1-2 0V16H3a1.75 1.75 0 0 1-1.75-1.75V7.5c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v6.75A1.75 1.75 0 0 1 21 16h-2v2.75a1 1 0 1 1-2 0V16zM3.54 7.75 9.79 14h3.92L7.46 7.75zM3.25 14v-3.71L6.96 14zm17.21 0h-3.92l-6.25-6.25h3.92zm.29-6.25v3.71l-3.71-3.71z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBarricade;